import * as React from 'react';
import { ButtonPrimary } from 'common--design-library';
import { translation } from 'easit--localization';

export interface IErrorBoundaryLoggerService {
    logError(error: Error, info: Object): void;
}

export interface IErrorBoundaryProps {
    onContinueClick: () => void;
    errorLoggingService: IErrorBoundaryLoggerService;
}

export class ErrorBoundary extends React.Component<IErrorBoundaryProps, { hasError: boolean }> {

    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, info: Object) {
        this.setState({ hasError: true });
        if (this.props.errorLoggingService) {
            this.props.errorLoggingService.logError(error, info);
        }
    }

    render() {
        // see componentDidCatch, error and info
        if (this.state.hasError) {
            return <div className="d-flex align-items-center justify-content-center py-4">
                <div className={"mr-2"}>{translation().something_went_wrong}</div>
                <ButtonPrimary onClick={this.props.onContinueClick}>{translation().refresh}</ButtonPrimary>
            </div>;
        }
        return this.props.children;
    }
}